<template>
    <el-container>
        <el-aside class="app_aside">
            <div class="app_logo">
                <img src="../assets/logo.png" alt="">
            </div>
            <MyAside :asideId="app_asideId"></MyAside>
        </el-aside>
        <el-container>
            <el-header>
                <MyHeader></MyHeader>
            </el-header>
            <div class="app_con">
                <div class="app_Rig app_RigW">
                    <div class="app_TNav">
                        <div class="app_TList">
                          <div class="app_TItem"
                               v-for="(todo, index) in todos"
                               :class="{ app_TAct: activeTabIndex === index }"
                               @click="switchTab(index)">
                            {{todo.title}} <i class="el-icon-close" @click.stop="removeTodo(index)" v-if="index>0"></i>
                          </div>
                        </div>
                    </div>
                    <el-main>
                        <div class="hall_Top">
                            <div class="hallFrom">
                                <el-form ref="hallFrom" :model="hallFrom" label-width="80px">
                                    <el-form-item label="关键词:" class=" taskItem">
                                        <el-input v-model="hallFrom.name"
                                            placeholder="任务编号/客户名称/客户手机号"></el-input>
                                    </el-form-item>
                                    <el-form-item label="类型:" class="taskItem">
                                        <el-select v-model="hallFrom.types" placeholder="请选择类型">
                                            <el-option label="短视频" value="1"></el-option>
                                            <el-option label="图片处理" value="2"></el-option>
                                            <el-option label="PPT" value="3"></el-option>
                                            <el-option label="CAD效果图" value="4"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="价格区间:" class="taskItem hallJg">
                                        <el-input v-model="hallFrom.number1" placeholder="最高价">
                                            <template slot="prepend">￥</template></el-input>
                                        <i class="el-icon-minus"></i>
                                        <el-input v-model="hallFrom.number2" placeholder="最低价">
                                            <template slot="prepend">￥</template></el-input>
                                    </el-form-item>
                                  <el-form-item label="发布时间:" class="taskItem hallJg">
                                    <el-date-picker v-model="hallFrom.time" type="daterange" range-separator="至"
                                                    start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                                  </el-form-item>
                                    <div class="taskFBon">
                                        <el-button icon="el-icon-refresh" @click="hallFrom=[];list()">重置</el-button> <el-button
                                            icon="el-icon-search" @click="list">搜索</el-button>
                                    </div>
                                </el-form>
                            </div>
                        </div>
                        <div class="taskCon">
                            <div class="taskCTit">
                                <p>任务列表</p>
                                <div class="taskCRig" @click="fetchTableData()">
                                    <i class="el-icon-refresh-left"></i>
                                </div>
                            </div>
                            <div class="taskCTable">
                                <el-table :data="taskList" border>
                                    <el-table-column fixed prop="bh" label="任务编号" width="180">
                                    </el-table-column>

                                    <el-table-column prop="fbsjtime" label="发布时间" width="220">
                                    </el-table-column>

                                    <el-table-column prop="type" label="任务类型" width="160">
                                    </el-table-column>
                                    <el-table-column prop="xcon" label="需求描述" width="300">
                                    </el-table-column>
                                    <el-table-column prop="yjprice" sortable label="任务佣金" width="150">
                                    </el-table-column>
                                    <el-table-column prop="bzprice" label="保证金" sortable width="150">
                                    </el-table-column>
                                    <el-table-column prop="sjprice" label="手续费" sortable width="150">
                                    </el-table-column>
                                    <el-table-column prop="jgtime" label="交稿时限" sortable width="220">
                                    </el-table-column>
                                  <el-table-column prop="xma" label="联系人" width="120">
                                    <template slot-scope="scope">
                                      <p v-if="scope.row.hm">{{scope.row.hm}}</p>
                                      <p v-else>{{scope.row.xm}}</p>
                                    </template>
                                  </el-table-column>

<!--                                    <el-table-column label="微信二维码" width="150">-->
<!--                                      <template slot-scope="scope">-->
<!--                                        <img :src="scope.row.wx" @click="handleImageClick(scope.row.wx)" style="height: 25px; cursor: pointer;object-fit: cover;" />-->
<!--                                      </template>-->
<!--                                    </el-table-column>-->
                                  <el-table-column fixed="right" label="操作" width="120">
                                      <template slot-scope="scope"> <!-- 在 Element UI 2.x 中使用 slot-scope -->
                                        <!-- 如果使用 Element UI 3.x+，应使用 v-slot:default="scope" -->
                                        <el-button class="app_mlTableCk" type="text"
                                                   size="small" @click="detailsShowa(scope.row.id)">查看</el-button>
                                      </template>
                                    </el-table-column>
                                </el-table>
                              <div class="app_page" v-if="taskList.length>0">
                                <el-pagination
                                    @size-change="sizechange"
                                    @current-change="handleCurrentChange"
                                    layout="sizes, prev, pager, next"
                                    :page-sizes="[10,50,80,100]" :page-size="10" :total="pagesize" :current-page="onpage">
                                </el-pagination>
                              </div>
                              <el-empty description="暂无数据" v-else></el-empty>
                            </div>
                        </div>
                        <el-dialog title="订单详情" class="TaskDetails" :visible.sync="detailsShow">
                            <div class="TaskDTbox" v-html="listcon.html">
                            </div>
                            <div slot="footer" class="dialog-footer">
                                <el-button type="primary" @click="releaseShow=true">我要接任务</el-button>
                                <el-button @click="detailsShow = false" class="Password_hide">取 消</el-button>
                            </div>
                        </el-dialog>
                        <el-dialog title="接单" class="Password release" :visible.sync="releaseShow">
                          <div class="relTit">
                            <h4>接单将支付保证金,手续费</h4>
                            <div class="relNum" v-html="listcon.price">
                            </div>
                          </div>
                          <div class="relText">
                            接单前仔细阅读任务要求，不清楚可提前联系发单人了解，确认后再接单；
                            设计师接单后请立即主动联系发单人对接任务；
                            诱导线下交易、辱骂等违规行为，将会被扣除部分或全部保证金、冻结账户处罚。
                          </div>
                          <div slot="footer" class="dialog-footer">
                            <el-button @click="releaseShow = false" class="Password_hide">取 消</el-button>
                            <el-button type="primary" @click="alipaytShowa(listcon.id)">确 定</el-button>
                          </div>
                        </el-dialog>
                        <el-dialog
                            title="图片查看"
                            :visible.sync="dialogVisible"
                            width="30%"
                            :before-close="handleClose">
                          <img :src="currentImage" style="width: 100%" />
                        </el-dialog>
                    </el-main>
                </div>
            </div>
        </el-container>
    </el-container>
</template>

<script>
import axios from "axios";

export default {
    // 指定 name 选项的另好处是便于调试。有名字的组件有更友好的警告信息.
    // 另外，当在有 vue-devtools，未命名组件将显示成 <AnonymousComponent>，这很没有语义。通过提供 name 选项，可以获得更有语义信息的组件树。
    name: 'reception_hall',
    data() {
        return {
            app_asideId: 3,
            hallFrom: [],
            detailsShow: false,
          releaseShow: false,
            taskList: [],
          todos:[],
          onpage:0,
          pagesize:0,
          listcon:[],
          dialogVisible: false,
          currentImage: '',
        }
    },
    beforeRouteLeave(to, from, next) {
      this.$store.commit('savePageState', {
        pageName: "reception_hall",
        pageState: {
          hallFrom: this.hallFrom,
          onpage: this.onpage,
          pagesize: this.pagesize
        }
      });
      next();
    },
    // 这里为了测试被切换的组件去哪了
    mounted() {
      this.todos=this.$store.state.tags
      let todos= this.todos
      console.log(this.todos);
      let index =todos.findIndex(note => note.path === "reception_hall");

      if(index>=0){
        this.activeTabIndex=index
      }else{
        const newNote = {
          title: "接单大厅",
          path: 'reception_hall'
        }
        this.$store.state.tags.push(newNote);
        this.activeTabIndex=this.todos.length - 1
      }
      this.userpath=this.$store.state.userpath
      this.fetchTableData();
      let savedState = this.$store.state.pageState["reception_hall"];
      if (savedState) {
        this.hallFrom=savedState.hallFrom
        this.pagesize=savedState.pagesize
        this.onpage=savedState.onpage
        this.handleCurrentChange(this.onpage)
      }
    },
    methods: {
      handleImageClick(imageSrc) {
        this.currentImage = imageSrc;
        this.dialogVisible = true;
      },
      handleClose(done) {
        this.dialogVisible = false;
        done();
      },
      switchTab(index) {
        this.$router.push(this.todos[index].path); // 使用push保留历史记录，或使用replace不保留
      },
      removeTodo(index) {
        this.todos.splice(index, 1);
        this.$forceUpdate();
        if(index==this.activeTabIndex){
          this.$router.push(this.todos[index].path);
        }else if(index<this.activeTabIndex){
          this.activeTabIndex=this.activeTabIndex-1
        }
      },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        on_order(e) {
            console.log('e', e)
            this.app_asideId = e
            if (e == 1) {
                this.$router.push('/Publish_task')
            } else if (e == 2) {
                this.$router.push('/tasklist')
            } else if (e == 3) {
                this.$router.push('/order')
            } else if (e == 4) {
                this.$router.push('/Home')
            }

        },
      fetchTableData(){
        axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=orderlist')
            .then(response => {
              this.taskList = response.data.arr;
              this.pagesize = response.data.pagesize;
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      list(){
        console.log(222)
        const formDataa = {
          ...this.hallFrom // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=orderlist', formDataa, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.taskList=data.arr
                this.pagesize=data.pagesize
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      sizechange(val){
        this.hallFrom.size = val
        this.hallFrom.page = 0
        const formDataa = {
          ...this.hallFrom // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=orderlist', formDataa, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.taskList=data.arr
                this.pagesize=data.pagesize
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      handleCurrentChange(val){
        this.hallFrom.page = val
        const formDataa = {
          ...this.hallFrom // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=orderlist', formDataa, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.taskList=data.arr
                this.pagesize=data.pagesize
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      detailsShowa(e){
        axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=order_info_jd&id='+e)
            .then(response => {
              this.listcon = response.data.arr;
              console.log(this.listcon.price)
              this.detailsShow = true;
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },

      alipaytShowa(e){
        axios.get(this.$store.state.apiUrl+'/?a=ajax_edit&m=order_jd&id='+e)
            .then(response => {
              if(response.data.status==1){
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
                this.releaseShow = false;
                this.detailsShow = false;
                this.handleCurrentChange(this.onpage)
                this.$router.push('/order')
              }else{
                this.$message({
                  type: 'info',
                  message: response.data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      }
    },
}
</script>

<style>
.hallFrom {
    padding: 20px;
    background: #fff;
    border-radius: 16px;
}

.hallFrom .el-form {
    display: flex;
    flex-wrap: wrap;
}

.hallItem {
    width: 22%;
}

.hallJg .el-form-item__content {
    display: flex;
    align-items: center;
}
.hallJg .el-form-item__content {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
}

.el-input-group__append,
.el-input-group__prepend {
    border: none !important;
    background: transparent !important;
    padding: 0 10px !important;
}

.taskCTable .el-table .sort-caret.descending {
    border-top-color: #fff;
}

.taskCTable .el-table .sort-caret.ascending {
    border-bottom-color: #fff;
    top: 5px;
}

.taskCTable .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #ff5000;
}

.taskCTable .el-table .descending .sort-caret.descending {
    border-top-color: #ff5000;
}

.taskCTable .el-table td.el-table__cell div {
    display: inline-block;
    /*white-space: nowrap;*/
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 订单详情 */
.TaskDetails {
    width: 100%;
}

.TaskDetails .el-dialog {
    width: 80% !important;
    min-width: 900px !important;
    margin-top: 7vh !important;
}

.TaskDetails .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 18px;
}

.TaskDTbox {
    width: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    border: 1px solid #f1f2f3;
    border-radius: 16px;
    overflow: hidden;
}

.TaskDItem {
    width: 33.3%;
    display: flex;
    border-bottom: 1px solid #f1f2f3;
}

.TaskDItem2 {
    width: 100%;
}
.TaskDItem3 {
    width: 50%;
}

.TaskDTit {
    width: 120px;
    padding: 15px;
    font-size: 14px;
    background: #f7f8f9;
    height: 100%;
}

.TaskDText {
    width: calc(100% - 120px);
    font-size: 14px;
    line-height: 25px;
    padding: 15px;
    height: 100%;
}

.TaskDetails .el-dialog__body {
    max-height: 650px;
    overflow: auto;
}

.TaskDetails .el-dialog__footer{
    text-align: center;
}





@media(max-width:1468px) {
    .hallItem {
        width: 35%;
    }
}

.relTit h4{
  font-size: 24px;
  text-align: center;
  color: #ff5000;
}
.relTit p{
  font-size: 16px;
  text-align: center;
  margin: 15px 0
}
.relNum{
  font-size: 20px;
  color: #ff5000;
  text-align: center;
}
.relText{
  margin-top: 20px;
  line-height: 2;
}
.relText span{
  color: #ff5000;
}
.release .el-dialog__footer{
  text-align: center
}
</style>